import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// import store from '@/store';
import 'ant-design-vue/dist/reset.css'
import '@/style/global.less'
import i18n from '@/locales/useI18n'
import 'virtual:svg-icons-register'
import setupDefaultSetting from '@/utils/setupDefaultSetting'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

import Antd from 'ant-design-vue'
import * as AntDesignIcons from '@ant-design/icons-vue'
import AntButton from '@/components/antTools/AntButton.vue'
import AntPagination from '@/components/antTools/AntPagination.vue'
import AntTable from '@/components/antTools/AntTable.vue'
import AntModal from '@/components/antTools/AntModal.vue'
import { directive } from '@/directive/index'
import '@/utils/default-passive-events'
import '@/style/tailwind.css'
import '@/assets/iconfont/iconfont.css'

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.use(Antd)
Object.entries(AntDesignIcons).forEach(([name, component]) => {
  app.component(name, component)
})
app.component('AntButton', AntButton)
app.component('AntPagination', AntPagination)
app.component('AntTable', AntTable)
app.component('AntModal', AntModal)
app.use(router)
// app.use(store)
app.use(i18n)
directive(app)
app.mount('#app')

setupDefaultSetting()

window.env = import.meta.env.MODE
window.log = console.log
